import "./index.css";

export const Page404 = () => {
    return (
        <section className="section404">
            <h1>Erro 404 - Page Not Found</h1>
        </section>
    );
}